module.exports = __webpack_public_path__ + "img/image_vision.6ac63a04.jpg";